// extracted by mini-css-extract-plugin
module.exports = {"featureTooltip":"ProductFeatures_featureTooltip___oduU","featureTooltipDialog":"ProductFeatures_featureTooltipDialog__FnFH0"};